module.exports = __webpack_public_path__ + "static/trust-photo-0aa2a841b0f4228797495c2fe91cedba.jpg";